import { render, staticRenderFns } from "./view-office-expedition-shipment.vue?vue&type=template&id=353b9db2&"
import script from "./view-office-expedition-shipment.vue?vue&type=script&lang=js&"
export * from "./view-office-expedition-shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports